import React from 'react';
import './InlineLoader.css';

const InlineLoader = ({ text = "Loading..." }) => {
  return (
    <div className="inline-loader">
      <div className="loader-spinner"></div>
      <p className="loader-text">{text}</p>
    </div>
  );
};

export default InlineLoader; 